<template>
  <div class="personal-setting">
    <div class="content" :style="{ maxHeight: isMaximized ? '70vh' : '450px' }">
      <div class="title">传单状态校验</div>
      <div class="setting-item">
        <!-- <div>
          <span>是否开启审单校验？</span>
          <el-switch
            v-model="getConfigListItemByType('reviewStatus').value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div> -->
        <div>
          <span>无需校验服务单流程即可下单</span>
          <el-switch
            v-model="
              getConfigListItemByType('requireServiceContractCheck').value
            "
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>

          <el-checkbox
            v-if="
              getConfigListItemByType('requireServiceContractCheck').value ===
              'true'
            "
            v-model="
              getConfigExtendsOneItemByType('requireServiceContractCheck').value
            "
            true-label="true"
            false-label="false"
            >开放所有门店</el-checkbox
          >
          <el-select
            v-if="
              getConfigExtendsOneItemByType('requireServiceContractCheck')
                .value === 'false' &&
              getConfigListItemByType('requireServiceContractCheck').value ===
                'true'
            "
            size="small"
            :value="
              getConfigExtendsOneItemShopIdsByType(
                'requireServiceContractCheck',
              )
            "
            placeholder="选择门店"
            filterable
            multiple
            collapse-tags
            @change="changeShopByType($event, 'requireServiceContractCheck')"
          >
            <el-option
              v-for="item in shopOptions"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <mainContractNumberTag></mainContractNumberTag>
      <div v-if="false" class="title">下单范围校验</div>
      <div v-if="false" class="setting-item">
        <div>
          <span>是否允许跨门店经营权限下单？</span>
          <el-switch
            v-model="getConfigListItemByType('allowCrossStoreOrder').value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
          <el-checkbox
            v-if="
              getConfigListItemByType('allowCrossStoreOrder').value === 'true'
            "
            v-model="
              getConfigExtendsOneItemByType('allowCrossStoreOrder').value
            "
            true-label="true"
            false-label="false"
            >开放所有门店</el-checkbox
          >
          <el-select
            v-if="
              getConfigExtendsOneItemByType('allowCrossStoreOrder').value ===
                'false' &&
              getConfigListItemByType('allowCrossStoreOrder').value === 'true'
            "
            size="small"
            :value="
              getConfigExtendsOneItemShopIdsByType('allowCrossStoreOrder')
            "
            placeholder="选择门店"
            filterable
            multiple
            collapse-tags
            @change="changeShopByType($event, 'allowCrossStoreOrder')"
          >
            <el-option
              v-for="item in shopOptions"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            >
            </el-option>
          </el-select>
          <div
            v-if="
              getConfigListItemByType('allowCrossStoreOrder').value === 'true'
            "
          >
            若选择为是，则下单时校验商场经营权限，不再根据门店限制下单范围
          </div>
        </div>
        <el-divider
          v-if="
            getConfigListItemByType('allowCrossStoreOrder').value === 'true'
          "
        ></el-divider>
        <div
          class="org-channel"
          v-if="
            getConfigListItemByType('allowCrossStoreOrder').value === 'true'
          "
        >
          <div class="left">
            <div>
              商场存在同品牌品类多个招商渠道，请选择主合同号取号/下单时的招商渠道优先级
            </div>
            <div>（若门店已有的品牌品类则按门店关联的招商渠道取号）</div>
          </div>
          <div class="right">
            <div v-for="item in orgChannelConfig" :key="item.value">
              <span>{{ item.brandCategoryName }}</span>
              <el-input
                placeholder="配置招商渠道优先级"
                :value="getOrgChannelConfigHightestPriorityName(item)"
                size="small"
              >
              </el-input>
              <el-link type="primary" @click="handleOrgChannelConfig(item)"
                >配置</el-link
              >
            </div>
          </div>
        </div>
      </div>
      <CustomerDataPackageSetting
        ref="customerDataPackageRef"
        :key="componentKey"
      />
      <reviewOrderCondition
        ref="reviewOrderConditionRef"
        :key="componentKey + '_review'"
      ></reviewOrderCondition>
      <TransmissionPersonalizedSetting
        ref="transmissionPersonalizedRef"
        :key="componentKey + '_transmission'"
      />
    </div>

    <div class="footer">
      <el-button size="small" @click="handleCancel">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </div>
    <orgChannelConfigDialog
      :visible.sync="isShowOrgChannelConfigDialog"
      @confirm="handleOrgChannelConfirm"
      :item="currentOrgChannelConfigItem"
    ></orgChannelConfigDialog>
  </div>
</template>

<script>
import {
  productionOrderMarketConfigSaveOrgConfig,
  productionOrderMarketConfigQueryOrgChannels,
  productionOrderMarketConfigListByCondition,
  getFictitiousShopOptions,
} from "@/api/checkOrderByCustomer/index";
import { Loading } from "element-ui";
import orgChannelConfigDialog from "./orgChannelConfigDialog.vue";
import { reqGetCurrentUser, checkSpecial } from "@oppein/op-utils";
import CustomerDataPackageSetting from "./customerDataPackageSetting.vue";
import reviewOrderCondition from "./reviewOrderCondition.vue";
import TransmissionPersonalizedSetting from "./transmissionPersonalizedSetting.vue";
import mainContractNumberTag from "./mainContractNumberTag.vue";

export default {
  props: {
    isMaximized: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    orgChannelConfigDialog,
    CustomerDataPackageSetting,
    reviewOrderCondition,
    TransmissionPersonalizedSetting,
    mainContractNumberTag,
  },
  computed: {},
  data() {
    return {
      shopOptions: [], // 门店选项
      isShowOrgChannelConfigDialog: false, // 是否显示招商渠道配置弹窗
      currentUserInfo: {}, // 当前用户信息
      orgChannelConfig: [], // 门店招商渠道配置
      currentOrgChannelConfigItem: {}, // 当前招商渠道配置项
      configList: [], // 配置列表
      componentKey: Date.now(), // 用于强制重新渲染子组件
    };
  },
  methods: {
    /**
     * 确定
     */
    async handleConfirm() {
      let loadingInstance = Loading.service();

      try {
        const orgId = this.currentUserInfo.orgId;

        const configList = JSON.parse(JSON.stringify(this.configList));
        const orgChannelConfig = JSON.parse(
          JSON.stringify(this.orgChannelConfig),
        );

        const getConfigListItemByType = (type) => {
          const item = configList.find((item) => item.type === type);
          if (!item) throw new Error(`未找到类型为${type}的配置项`);
          return item;
        };

        const reviewStatus = getConfigListItemByType("reviewStatus");
        const requireServiceContractCheck = getConfigListItemByType(
          "requireServiceContractCheck",
        );
        // const allowCrossStoreOrder = getConfigListItemByType(
        //   "allowCrossStoreOrder",
        // );

        const brandCategoryPriorityConfiguration = [];

        // 校验“是否需校验订单必须关联服务单”若选择为是，且未勾选校验所有门店，需至少选择一个虚拟门店
        if (requireServiceContractCheck.value === "true") {
          const configExtendsOneItem = this.getConfigExtendsOneItemByType(
            "requireServiceContractCheck",
          );
          if (configExtendsOneItem.value === "true") {
          } else {
            if (!configExtendsOneItem.options) {
              this.$message.error(
                "当前已开启校验订单必须关联服务单，需至少选择一个虚拟门店",
              );
              return;
            }
          }
        }

        // // 校验“是否允许跨门店经营权限下单”若选择为是，且未勾选校验所有门店，需至少选择一个虚拟门店
        // if (allowCrossStoreOrder.value === "true") {
        //   const configExtendsOneItem = this.getConfigExtendsOneItemByType(
        //     "allowCrossStoreOrder",
        //   );
        //   if (configExtendsOneItem.value === "true") {
        //   } else {
        //     if (!configExtendsOneItem.options) {
        //       this.$message.error(
        //         "当前已开启允许跨门店经营权限下单，需至少选择一个虚拟门店",
        //       );
        //       return;
        //     }
        //   }
        // }

        // // 校验“是否允许跨门店经营权限下单”若选择为是，且存在同品牌品类有多个未淘汰的招商渠道时，每个品牌品类都已配置招商渠道优先级
        // if (allowCrossStoreOrder.value === "true") {
        //   const findNotPassItem = orgChannelConfig.find((item) => {
        //     const orgChannelConfigs = item.orgChannelConfigs || [];
        //     const isPass = orgChannelConfigs.every((config) => {
        //       const hasPriority =
        //         config.priority !== null &&
        //         config.priority !== undefined &&
        //         config.priority > 0;
        //       if (!hasPriority) {
        //         return false;
        //       }
        //       return true;
        //     });
        //     return !isPass;
        //   });
        //   if (findNotPassItem) {
        //     this.$message.error(
        //       `当前已开启允许跨门店经营权限下单，${findNotPassItem.brandCategoryName}品类存在多个有效的招商渠道，请配置招商渠道优先级`,
        //     );
        //     return;
        //   }
        // }

        // // 招商渠道配置数据拼接
        // orgChannelConfig.reduce((a, item) => {
        //   const orgChannelConfigs = item.orgChannelConfigs || [];
        //   const configExtends = [];
        //   orgChannelConfigs.forEach((orgChannelConfig) => {
        //     const { orgChannelCode, priority } = orgChannelConfig;
        //     const shops = orgChannelConfig.shops || [];
        //     const selectedShop = shops.find((shop) => shop.selected);
        //     configExtends.push({
        //       type: "channelPriorityConfiguration",
        //       value: orgChannelCode,
        //       options: selectedShop ? selectedShop.departmentId : "",
        //       priority: priority,
        //       description: "招商渠道优先级配置",
        //     });
        //   });
        //   const template = {
        //     orgId,
        //     type: "brandCategoryPriorityConfiguration",
        //     value: item.brandCategory,
        //     configExtends,
        //     description: "品牌品类多招商渠道优先级配置",
        //   };
        //   a.push(template);
        //   return a;
        // }, brandCategoryPriorityConfiguration);

        // console.log(requireServiceContractCheck.value, "value");

        // 先由子组件校验并设置默认值
        if (
          this.$refs.customerDataPackageRef &&
          this.$refs.customerDataPackageRef.validateAndSetDefaults
        ) {
          const customerDataPackageStatus =
            this.$refs.customerDataPackageRef.validateAndSetDefaults();
          if (!customerDataPackageStatus) {
            return;
          }
        }

        if (
          this.$refs.reviewOrderConditionRef &&
          this.$refs.reviewOrderConditionRef.validate
        ) {
          const reviewOrderConditionStatus =
            this.$refs.reviewOrderConditionRef.validate();
          if (!reviewOrderConditionStatus) {
            return;
          }
        }

        if (
          this.$refs.transmissionPersonalizedRef &&
          this.$refs.transmissionPersonalizedRef.validate
        ) {
          const transmissionPersonalizedStatus =
            this.$refs.transmissionPersonalizedRef.validate();
          if (!transmissionPersonalizedStatus) {
            return;
          }
        }

        if (requireServiceContractCheck.value == "false") {
          requireServiceContractCheck.configExtends[0].value = false;
          requireServiceContractCheck.configExtends[0].options = "";
          console.log(requireServiceContractCheck.configExtends[0]);
        }
        // console.log(requireServiceContractCheck, "requireServiceContractCheck");

        const params = [
          reviewStatus,
          requireServiceContractCheck,
          // allowCrossStoreOrder,
          // ...brandCategoryPriorityConfiguration,
        ];

        const res = await productionOrderMarketConfigSaveOrgConfig(params);
        if (!res.status) {
          return;
        }

        // 保存传单个性化设置
        this.$refs.transmissionPersonalizedRef &&
          (await this.$refs.transmissionPersonalizedRef.saveData());

        // 保存客户资料包设置
        this.$refs.customerDataPackageRef &&
          (await this.$refs.customerDataPackageRef.saveData());

        // 保存审单条件设置
        this.$refs.reviewOrderConditionRef &&
          (await this.$refs.reviewOrderConditionRef.saveData());

        // 刷新数据
        this.$refs.transmissionPersonalizedRef &&
          this.$refs.transmissionPersonalizedRef.refreshData();
        this.$refs.customerDataPackageRef &&
          this.$refs.customerDataPackageRef.refreshData();
        this.$refs.reviewOrderConditionRef &&
          this.$refs.reviewOrderConditionRef.refreshData();

        this.handleSave();
      } catch (err) {
        console.log(err);
      } finally {
        loadingInstance.close();
      }
    },
    /**
     * 获取门店招商渠道配置
     */
    async getOrgChannelConfig() {
      // 如果是集团用户，则不查询
      if (this.currentUserInfo.orgId === "1") {
        this.orgChannelConfig = [];
        return;
      }

      const params = {
        orgId: this.currentUserInfo.orgId,
      };
      const res = await productionOrderMarketConfigQueryOrgChannels(params);
      if (!res.status) return;
      // 处理门店默认选中,如果没有选中的门店，默认选中第一个
      const list = res.data || [];
      list.forEach((item) => {
        item.orgChannelConfigs.forEach((orgChannelConfig) => {
          const shops = orgChannelConfig.shops || [];
          if (!shops.length) return;
          const hasSelectedShop = shops.some((shop) => shop.selected);
          if (!hasSelectedShop) {
            shops[0].selected = true;
          }
        });
      });
      this.orgChannelConfig = list;
    },
    /**
     * 查询配置
     */
    async getConfig() {
      const orgId = this.currentUserInfo.orgId;
      const params = {
        orgId,
      };
      const res = await productionOrderMarketConfigListByCondition(params);
      if (!res.status) return;

      // 定义默认配置项
      const defaultConfigs = [
        {
          orgId,
          type: "reviewStatus",
          value: "false",
          configExtends: [],
          description: "开启审单校验",
        },
        {
          orgId,
          type: "requireServiceContractCheck",
          value: "false",
          configExtends: [
            {
              type: "validateAllStores",
              value: "false",
              options: null,
              priority: null,
              description: "校验所有门店",
            },
          ],
          description: "无需校验服务单流程即可下单",
        },
        {
          orgId,
          type: "allowCrossStoreOrder",
          value: "false",
          configExtends: [
            {
              type: "openAllStores",
              value: "false",
              options: null,
              priority: null,
              description: "开放所有门店",
            },
          ],
          description: "是否允许跨门店经营权限下单",
        },
      ];

      if (!res.data || !res.data.length) {
        this.configList = defaultConfigs;
        return;
      }

      const configMap = new Map();
      res.data.forEach((config) => {
        configMap.set(config.type, config);
      });

      defaultConfigs.forEach((defaultConfig) => {
        if (!configMap.has(defaultConfig.type)) {
          configMap.set(defaultConfig.type, defaultConfig);
        }
      });

      this.configList = Array.from(configMap.values());
    },
    /**
     * 根据类型获取配置项
     * @param {String} type
     */
    getConfigListItemByType(type) {
      if (!this.configList || !this.configList.length) return {};
      const item = this.configList.find((item) => item.type === type);
      if (!item) throw new Error(`未找到类型为${type}的配置项`);
      return item;
    },
    /**
     * 获取配置项中的第一项
     * @param {String} type
     */
    getConfigExtendsOneItemByType(type) {
      if (!this.configList || !this.configList.length) return {};
      const { configExtends } = this.getConfigListItemByType(type);
      if (!configExtends || !configExtends.length)
        throw new Error(`类型为${type}的配置项,不存在configExtends`);
      return configExtends[0];
    },
    /**
     * 根据类型获取配置项中的门店ids
     * @param {String} type
     */
    getConfigExtendsOneItemShopIdsByType(type) {
      const item = this.getConfigExtendsOneItemByType(type);
      return item.options ? item.options.split(",") : [];
    },
    /**
     * 根据类型修改门店
     * @param {Array} value
     * @param {String} type
     */
    changeShopByType(value, type) {
      const item = this.getConfigExtendsOneItemByType(type);
      item.options = value.join(",");
    },
    /**
     * 查询配置
     */
    async getShopOptions() {
      const params = {
        orgId: this.currentUserInfo.orgId,
      };
      const res = await getFictitiousShopOptions(params);
      if (!res.status) return;
      this.shopOptions = res.data;
    },
    /**
     * 取消
     */
    handleCancel() {
      this.$emit("cancel");
    },
    /**
     * 保存
     */
    handleSave() {
      this.$message.success("保存成功");
      this.$emit("save");
    },
    handleOrgChannelConfirm(value) {
      console.log(value);
      // 找到对应的项，直接替换更新
      const index = this.orgChannelConfig.findIndex(
        (item) => item.brandCategory === value.brandCategory,
      );
      this.orgChannelConfig.splice(index, 1, value);
    },
    /**
     * 处理招商渠道配置
     * @param item
     */
    handleOrgChannelConfig(item) {
      this.currentOrgChannelConfigItem = item;
      this.isShowOrgChannelConfigDialog = true;
    },
    async init() {
      this.currentUserInfo = await reqGetCurrentUser();
      this.getOrgChannelConfig();
      this.getConfig();
      this.getShopOptions();
    },
    /**
     * 获取门店招商渠道配置中优先级最高的招商渠道名称
     * @param {Object} item
     */
    getOrgChannelConfigHightestPriorityName(item) {
      // 是否有配置
      const isHasConfig =
        item.orgChannelConfigs &&
        item.orgChannelConfigs.some(
          (item) => item.priority !== null && item.priority !== undefined,
        );
      if (!isHasConfig) return;
      const newOrgChannelConfigs = item.orgChannelConfigs.toSorted(
        (a, b) => a.priority - b.priority,
      );
      if (newOrgChannelConfigs.length > 0) {
        const { orgChannelName, orgChannelCode, shops } =
          newOrgChannelConfigs[0];

        const findShop = shops && shops.find((shop) => shop.selected);
        const departmentName = (findShop && findShop.departmentName) || "";

        return `${orgChannelName}（${orgChannelCode}）${departmentName ? "-" : ""} ${departmentName}`;
      }
      return;
    },
    /**
     * 处理审单白名单
     */
    async handleReviewOrderWhiteList() {
      const currentUser = await reqGetCurrentUser();
      const status = await checkSpecial(
        {
          platformName: "一键下单",
          business: "审单功能试点商场名单",
          rosterType: "白名单",
          objectType: "商场编码",
          orgNo: currentUser.orgNo,
        },
        {},
      );
      this.isReviewOrderWhiteList = status;
    },
  },
  async mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.personal-setting {
  > .content {
    overflow-y: auto;
    > .title {
      color: var(--color-primary);
      font-size: 16px;
      font-weight: bold;
      border-left: 4px solid var(--color-primary);
      padding-left: 5px;
    }
    > .setting-item {
      background-color: #f1f1f1;
      padding: 10px;
      line-height: 2.5em;
      margin: 10px 0;
      .org-channel {
        display: flex;
        max-height: 200px;
        overflow-y: auto;
        .left {
          flex: 1;
          margin-right: 10px;
        }
        .right {
          flex: 1;
          > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            white-space: nowrap;
            color: var(--color-danger);
            .el-input {
              margin: 0 10px;
            }
          }
        }
      }
    }
  }
  > .footer {
    padding-top: 10px;
    display: flex;
    justify-content: center;
    gap: 20px;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// functionSetting.vue?c5c825a0